export class InvalidContext extends Error {
    constructor (contextName, providerName) {
        super(`${contextName} is undefined, please nest it in an ${providerName}`);
    }
}